import {ServiceRequestService} from './../../../../../Services/service-request.service';
import {Subscription} from 'rxjs';
import {ServiceRequest} from './../../../../../../back-office/Models/ServiceRequest';
import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ActionConfirm} from './../../../../../Models/ActionConfirm';

@Component({
  selector: 'app-reply-step-confirmation',
  templateUrl: './reply-step-confirmation.component.html',
  styleUrls: ['./reply-step-confirmation.component.scss']
})
export class ReplyStepConfirmationComponent implements OnInit, OnDestroy {

  @Input() Index;
  @Input() isActive;

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public selectedOption = 0;

  constructor(
    private requestService: ServiceRequestService,
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        this.request.reply.replyItems = this.request.reply.replyItems.filter(item => !item.solutionStep.restricted);
        if (this.request.reply.replyItems[this.Index].replyConfirm) {
          this.selectedOption = this.request.reply.replyItems[this.Index].replyConfirm.selectedOption;
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public confirmTypeIsBackoffice() {
    return this.request.reply.replyItems[this.Index].solutionStep.actionConfirm.type === ActionConfirm.BACKOFFICE_TYPE;
  }

  confirmStep() {
    const data = {selectedOption: this.selectedOption};
    this.subscriptions.push(
      this.requestService.confirmStep({
        serviceRequest: this.request.id,
        replyItem: this.request.reply.replyItems[this.Index].id,
        data: data
      }).subscribe(res => {
        this.requestService.fetchServiceRequestComplete(this.request.id, false);
      })
    );
  }


}
